
import Alert from 'vux/src/components/alert/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'

export default {
components: {
Flexbox,
FlexboxItem,
XImg,
Group,
PopupPicker,
XTextarea,
XButton,
Alert,
loadPage,
XHeader,
XInput
},
data(){
return{
repair:"",
info:'',
filecontent:[],
comnCode:'',
hsNo:'',
textms:'商品描述\n（为免打扰，请勿泄露个人电话、微信等信息）',
preices:'0.00元',
preices1:'0.00元',
lisColor:'',
mSval:'最多可以上传四张图片',
message:'',
alrtext:'商品标题(不能超过15个字)',
showAlert:false,
show_1:false,
useragent:'',
alrtext1:'',
value5:"",
infoValue:"",
lisType:'',
alertShow:false,
alertMsg:"",
values:'',
value3:[],
value4:[],
list3:[[]],
list4:[[]],
rsValue:'',
stateMcode:'',
comnList:'',
colorId:'',
eType:''

}
},
beforeMount(){
if(this.$router.history.current.path == "/marketResend"){
document.title = "去发布";
}
this.value5 = this.$router.history.current.query.phone;
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
this.getTypeList();
},
methods:{
deleteImg(index){
this.filecontent.splice(index,1)
},
comval(){
$("#m1").find(".weui-label").css('color','#000');
$("#m2").find(".weui-label").css('color','#000');
$("#m3").find(".weui-label").css('color','#000');
$("#m4").find(".weui-label").css('color','#000')
},
selectFile(){
this.mSval = '最多可以上传四张图片';
let filehandler = document.getElementById('file')
if(filehandler.files){
let fileList = filehandler.files;
let self = this;
let size = this.filecontent.length
console.log(size)
/*for(let j = 0 ; j < size ; j++){
this.filecontent.pop();
}*/
if(size > 3){
this.filecontent.pop();
}
for(let i = 0 ; i < (fileList.length > 4 ? 4 :fileList.length) ; i++){
var reader = new FileReader();
reader.readAsDataURL(fileList[i]);
reader.onload = function (event) {
var img = new Image;


let width = 680, //图像大小
quality = 0.8, //图像质量
canvas = document.createElement("canvas"),
drawer = canvas.getContext("2d");
img.src = this.result;
img.onload = function () {
canvas.width = width;
canvas.height = width * (img.height / img.width);
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
let imgBase64 = canvas.toDataURL("image/jpeg", quality);
self.filecontent.push(imgBase64);
img.src="";
}

}

}
}
},
getTypeList(){//获取成色和分类的数据
let url = global.host + 'secondMarket/findfilter';
this.$http.get(url).then(function(res){
let datas = res.body;
this.comnList = res.body;
for(let i in datas){
if(datas[i].filterType == 1){
this.list4[0].push(datas[i].filterName);
}else if(datas[i].filterType == 3){
this.list3[0].push(datas[i].filterName);
}

}

},function(err){
console.log(err)
})
},
changeColor(index){//获取成色
$("#m5").find(".weui-label").css('color','#000')
for(let s in this.comnList){
if(this.comnList[s].filterName == index && this.comnList[s].filterType == 3){
this.colorId = this.comnList[s].filterId;
}
}

},
changeType(index){//获取分类
$("#m6").find(".weui-label").css('color','#000')
for(let s in this.comnList){
if(this.comnList[s].filterName == index && this.comnList[s].filterType == 1){
this.eType = this.comnList[s].filterId;
}
console.log(this.eType)
}
},
submitForm(){
if(this.infoValue == ''){
this.alrtext = '请输入内容';
$("#m1").find(".weui-label").css('color','#ff0000')
}else if(this.info == ''){
this.textms = '请输入内容';
}else if(this.filecontent.length == 0){
this.mSval = '请上传图片';
}else if(this.value5 == ''){
this.alrtext1 = '请输入手机号';
$("#m2").find(".weui-label").css('color','#ff0000')
}else if(this.values ==''){
this.preices = '请输入卖价';
$("#m3").find(".weui-label").css('color','#ff0000')
}else if(this.rsValue == ''){
this.preices1 = '请输入入手价';
$("#m4").find(".weui-label").css('color','#ff0000')
}else if(this.value3 == ''){
this.lisColor = "请选择";
$("#m5").find(".weui-label").css('color','#ff0000')
}else if(this.value4 == ''){
this.lisType = '请选择';
$("#m6").find(".weui-label").css('color','#ff0000')
}else{
this.show_1 = true;
let usInfo = new Object();
usInfo.comnCode = this.$router.history.current.query.comnCode;
usInfo.telePhone = this.$router.history.current.query.phone;
usInfo.mainPhone = this.$router.history.current.query.phone;
usInfo.comnName = this.$router.history.current.query.comnName;
usInfo.goodsName = this.infoValue;
usInfo.goodsType = this.eType;
usInfo.goodsLoss = this.colorId;
usInfo.buyPrice = this.rsValue;
usInfo.salePrice = this.values;
usInfo.goodsDesc = this.info;
usInfo.commoOrigiImg = this.filecontent;
usInfo.openId = this.$router.history.current.query.openid;
console.log(usInfo)
let url = global.host + 'secondMarket/releaseGoods';
this.$http.post(url,usInfo).then(function(res){
this.show_1 = false;
this.stateMcode = res.body.code;
let msgCode = res.body.code;
if(msgCode == '120'){
this.alertShow = true;
this.alertMsg = res.body.msg;
}else if(msgCode == '110'){
this.alertShow = true;
this.alertMsg = res.body.msg;
}
},function(err){
console.log(err)
})
}

},
getIndex(arr,field){
for(let i = 0 ; i < arr.length ; i++){
if(arr[i] == field){
return i
}
}
},
onHide(){
if(this.stateMcode == '110'){
let openid = this.$router.history.current.query.openid;
let phone = this.$router.history.current.query.phone;
let comnCode = this.$router.history.current.query.comnCode;
let comnName = this.$router.history.current.query.comnName;
this.$router.push({path:'/fleaMarketList',query:{comnCode:comnCode,openid:openid,communityName:comnName,comnCode:comnCode}})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/marketResend.vue